import * as actionTypes from "../constants/actionTypes";

export const selectFromFavorites = (tabId, product, fandeck, color, base) => ({
    type: actionTypes.SELECT_FROM_FAVORITES,
    payload: {
        tabId: tabId,
        product: product,
        fandeck: fandeck,
        color: color,
        base: base
    }
});

export const removeFromFavorites = (tabId, favoriteId) => ({
    type: actionTypes.FAV_TAB_REMOVE_FROM_FAVORITES,
    payload: {
        id: favoriteId,
        tabId: tabId
    }
});

export const addFavoritesFolder = (tabId, parentId) => ({
    type: actionTypes.ADD_FAVORITES_FOLDER,
    payload: {
        tabId: tabId,
        parentId: parentId
    }
});

export const editFavoritesFolder = (tabId, folderId, newName) => ({
    type: actionTypes.EDIT_FAVORITES_FOLDER,
    payload: {
        tabId: tabId,
        folderId: folderId,
        newName: newName
    }
});

export const deleteFolder = (tabId, folderId, removeContent) => ({
    type: actionTypes.DELETE_FAVORITES_FOLDER,
    payload: {
        tabId: tabId,
        folderId: folderId,
        removeContent: removeContent
    }
});

export const selectFolder = (folderId) => ({
    type: actionTypes.SELECT_TAB_FAVORITE_FOLDER,
    payload: {
        folderId: folderId
    }
});

export const editFavorites = (tabId, favoriteId, folderId) => ({
    type: actionTypes.EDIT_FAVORITES,
    payload: {
        tabId: tabId,
        favoriteId: favoriteId,
        folderId: folderId
    }
});
